import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { FormattedCurrency } from '../../components/formatted-currency';
import { UserDateTimezoneFormat } from '../../components/user-date-timezone-format';
import { LabelWithValue } from './label-with-value';
import { messages } from './messages';
import style from './style.module.less';

export const Overview = ({ orderNumber, overview }) => {
  const createdDateTimeMessage = overview?.deliveryTimeEstimate ? (
    <UserDateTimezoneFormat dateTime={overview.deliveryTimeEstimate} showTime spaceBetweenTimeAndZone />
  ) : (
    '--'
  );
  return (
    <div className={style['overview-grid']}>
      <div>
        <div className={style['header-label']}>
          <FormattedMessage {...messages.overview} />
        </div>
        <div className={style['overview-values']}>
          <LabelWithValue label={<FormattedMessage {...messages.orderNumberLabel} />} value={orderNumber} />
          <LabelWithValue
            label={<FormattedMessage {...messages.totalShippingPriceLabel} />}
            value={<FormattedCurrency currencyCode={overview?.cost?.code} value={overview?.cost?.value ?? 0} />}
          />
          <LabelWithValue label={<FormattedMessage {...messages.estimatedDeliveryLabel} />} value={createdDateTimeMessage} />
        </div>
      </div>
      <div>
        <div className={style['header-label']}>
          <FormattedMessage {...messages.customerSelectedShipping} />
        </div>
        <div className={style['overview-values']}>
          <LabelWithValue label={<FormattedMessage {...messages.methodLabel} />} value={overview?.displayName ?? '--'} />
          <LabelWithValue label={<FormattedMessage {...messages.descriptionLabel} />} value={overview?.description ?? '--'} />
        </div>
      </div>
    </div>
  );
};

Overview.propTypes = {
  orderNumber: PropTypes.string.isRequired,
  overview: PropTypes.shape({
    cost: PropTypes.string,
    deliveryTimeEstimate: PropTypes.number,
    description: PropTypes.string,
    displayName: PropTypes.string,
  }).isRequired,
};
